import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import languageReducer from './slices/languageSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export default store;
